import { Router, NavigationEnd } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Authentication } from 'src/app/helpers/authentication';
import { Location } from '@angular/common';

interface Link {
  name: string;
  isFinal: boolean;
  url: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  public links: Link[] = [];
  public auth: Authentication = new Authentication();

  constructor(private readonly router: Router, private readonly location: Location) { }

  ngOnInit(): void {
    this.router.events.subscribe(
      event => {
        if (event instanceof NavigationEnd) {
          const linkInfo = this.getLinkInfo(event.url);
          if (linkInfo.name != "") {
            this.updateBreadcrumb(event.url, linkInfo.isFinal, linkInfo.isRoot);
          }
        }
      }
    );
  }

  private updateBreadcrumb(url: string, isFinal: boolean, isRoot: boolean): void {
    // Desmarcar todos los enlaces como no finales
    this.links.forEach(link => link.isFinal = false);

    // Si es raíz, reiniciar el breadcrumb
    if (isRoot) {
      this.links = [];
    }

    // Buscar si ya existe el enlace en los breadcrumbs
    let existingLinkIndex = this.links.findIndex(link => link.url === url);

    if (existingLinkIndex === -1) {
      // Si no existe, agregarlo
      this.links.push({
        name: this.getLinkInfo(url).name,
        isFinal: isFinal,
        url: url
      });
    } else {
      // Si existe, cortar la lista hasta ese punto
      this.links = this.links.slice(0, existingLinkIndex + 1);
      this.links[this.links.length - 1].isFinal = isFinal;
    }

    // Si el enlace es final, truncar la lista para no agregar más
    if (isFinal) {
      this.links = this.links.slice(0, this.links.length);
    }
  }

  private getLinkInfo(url: string): { name: string, isFinal: boolean, isRoot: boolean } {
    if (url.includes("ofertDetails")) {
      return { name: "Detalle de oferta", isFinal: false, isRoot: false };
    } else if (url.includes("proyectDetails")) {
      return { name: "Detalle de proyecto", isFinal: true, isRoot: false };
    } else if (url.includes("ofertForm")) {
      return { name: "Crear oferta", isFinal: true, isRoot: true };
    } else if (url.includes("proyectForm")) {
      return { name: "Crear proyecto", isFinal: true, isRoot: false };
    } else if (url.includes("proyects")) {
      return { name: "Proyectos", isFinal: false, isRoot: true };
    } else if (url.includes("home")) {
      return { name: "Inicio", isFinal: false, isRoot: true };
    } else if (url.includes("offerts")) {
      return { name: "Ofertas", isFinal: false, isRoot: true };
    } else if (url.includes("employees")) {
      return { name: "Empleados", isFinal: false, isRoot: true };
    } else if (url.includes("interested")) {
      return { name: "Interesados", isFinal: false, isRoot: true };
    } else if (url.includes("roles")) {
      return { name: "Roles", isFinal: false, isRoot: true };
    } else if (url.includes("registerTime")) {
      return { name: "Time tracker", isFinal: false, isRoot: true };
    }
    //pais
    else if (url.includes("pais")) {
      return { name: "Paises", isFinal: false, isRoot: true };
    }
    //customers
    else if (url.includes("customers")) {
      return { name: "Clientes", isFinal: false, isRoot: true };
    }
    return { name: "", isFinal: false, isRoot: false };
  }
}
